// extracted by mini-css-extract-plugin
module.exports = {"root":"root","container":"container","main-container":"main-container","app":"app","layout-app":"layout-app","page-match":"page-match","breadcrumb":"breadcrumb"};